export default __webpack_public_path__ + "mytributes/images/fallback1.jpg";